<div class="c-videoAdsRewardModal">
  <div class="c-videoAdsRewardModal__background">
    <div class="c-videoAdsRewardModal__info">
      <span>{{ 'home.lobby.modals.video-ads.title' | translate | uppercase }}</span>
      <span>{{ 'home.lobby.modals.video-ads.subtitle' | translate }}</span>
    </div>

    <div class="c-videoAdsRewardModal__reward">
      <span>{{ videoadsRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate) }}</span>
    </div>
  </div>

  <slotcom-button
    class="c-button--pink"
    (safeClick)="closeModal()"
    audioType="reward">
    {{ 'home.buttons.collect' | translate | uppercase }}
  </slotcom-button>
</div>
